import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { CourseService } from 'src/app/services/course.service';
import { UsersService } from 'src/app/services/users.service';
import * as _ from 'lodash';
import { environment } from 'src/environments/environment';
import { ToastrService } from 'ngx-toastr';
import { SubscriptionService } from 'src/app/services/subscription.service';
import { ISubscription } from 'src/app/interfaces/subscriptions/SubscriptionRecord';

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.scss']
})
export class DashboardComponent implements OnInit {
  @ViewChild('courses', { read: ElementRef }) public courses: ElementRef<any>;
  public selectedTab: any = 'dashboard';
  public userDetails: any;
  public myCourses: any[] = [];
  public purchasedCoursesIds: any[] = [];
  public suggestedCourses: any[] = [];
  public selectedCourse: any = {};
  public apiURL: any = environment.apiURL;
  public subscriptionRecord: ISubscription;
  public showStopRenewalPopup: boolean = false;
  public stopRenewalReason: string = '';
  public stopRenewalFeedback: string = '';

  rejectionCodes: string[] = [
    'PAYMENT_FAILURE',
    'OTHERS',
    'NOT_INTERESTED',
    'TIME_CONSTRAINTS',
    'TOO_ADVANCED',
    'TOO_BASIC',
    'TOO_LONG',
    'TOO_SHORT',
    'ADJUST_SPEED'
  ];;
  constructor(
    private router: Router,
    private usersService: UsersService,
    private courseService: CourseService,
    private sanitizer: DomSanitizer,
    private toastrService: ToastrService,
    private subscriptionService: SubscriptionService
  ) { }

  ngOnInit(): void {
    if (JSON.parse(sessionStorage.getItem('dashboardTab'))) {
      this.selectedTab = JSON.parse(sessionStorage.getItem('dashboardTab'));
    }
    else {
      sessionStorage.setItem('dashboardTab', JSON.stringify(this.selectedTab));
    }
    this.getUserDetails();
    this.getAllPurchasedCourses();
  }

  public scrollRight(): void {
    if (window.innerWidth > 600)
      this.courses.nativeElement.scrollTo({ left: (this.courses.nativeElement.scrollLeft + 350), behavior: 'smooth' });
    else
      this.courses.nativeElement.scrollTo({ left: (this.courses.nativeElement.scrollLeft + 311), behavior: 'smooth' });

  }

  getAllPurchasedCourses() {
    this.courseService.getAllPurchasedCourse().subscribe(
      (res: any) => {
        if (res.length) {
          this.myCourses = res;
          for (let i = 0; i < res.length; i++) {
            this.purchasedCoursesIds.push(res[i]._id);
          }
          this.onClickMyCourse(res[0]);
          this.getAllSuggestedCourses();
        }
      }
    )
  }

  getAllSuggestedCourses() {
    this.courseService.getAllPublishedCourses().subscribe(
      (res: any) => {
        for (let i = 0; i < res.length; i++) {
          if (!this.purchasedCoursesIds.includes(res[i]._id)) {
            this.suggestedCourses.push(res[i]);
            if (this.suggestedCourses.length == 5) {
              break;
            }
          }
        }
      }
    )
  }

  onClickSuggestedCourse(course) {
    this.router.navigate(['courses/details/' + course._id]);
  }

  onClickMyCourse(course) {
    // this.router.navigate(['courses/play/' + course.courseId._id]);
    this.courseService.getLatestPlayedVideoOfCourse(course._id).subscribe((res: any) => {
      this.selectedCourse['course'] = course;
      this.selectedCourse['lastPlayedModule'] = res.module;
      this.selectedCourse['lastPlayedLesson'] = res.lesson;
    });
  }

  onClickReactivateSubscription() {
    this.router.navigate(['pricing']);
  }

  onClickStopRenewal() {
    this.showStopRenewalPopup = true;
  }

  closeStopRenewalPopup() {
    this.showStopRenewalPopup = false;
    this.stopRenewalReason = '';
    this.stopRenewalFeedback = '';
  }

  confirmStopRenewal() {
    console.log('Reason:', this.stopRenewalReason);
    console.log('Feedback:', this.stopRenewalFeedback);

    const cancellation = {
      cancellation_code: this.stopRenewalReason,
      cancellation_reason: this.stopRenewalFeedback,
    }

    this.subscriptionService.cancelSubscription(this.subscriptionRecord._id, { cancellation }).subscribe((res) => {
      this.toastrService.success('Subscription cancelled successfully');
      this.getUserDetails();
    }, (err) => {
      this.toastrService.error(err.message);
    });
    this.closeStopRenewalPopup();
  }


  formatRenewalReason(code: string): string {
    if (!code) return '';
    return code.replace(/_/g, ' ').toLowerCase();
  }
  getUserDetails() {
    let userId = JSON.parse(sessionStorage.getItem('logged-in-user'))._id;
    this.usersService.getUserDetails(userId).subscribe(
      async (res: any) => {
        this.userDetails = res;
        const subscriptionResponse = await this.subscriptionService.getSubscriptionForUser(userId).toPromise();
        this.subscriptionRecord = _.get(subscriptionResponse, 'data.data.subscriptionRecord');
      }, (err: any) => {
        this.toastrService.error(err?.error?.message);
      }
    )
  }

  isPaymentVerified() {
    this.getUserDetails();
  }

  public scrollLeft(): void {
    if (window.innerWidth > 600)
      this.courses.nativeElement.scrollTo({ left: (this.courses.nativeElement.scrollLeft - 350), behavior: 'smooth' });
    else
      this.courses.nativeElement.scrollTo({ left: (this.courses.nativeElement.scrollLeft - 311), behavior: 'smooth' });
  }

  onSelectTab(event) {
    if (event == 'dashboard') {
      this.getUserDetails();
    }
    this.selectedTab = event;
    sessionStorage.setItem('dashboardTab', JSON.stringify(this.selectedTab));
  }

  getImage(image) {
    return this.sanitizer.bypassSecurityTrustResourceUrl(image);
  }

  onClickVideo(selectedCourse) {
    sessionStorage.setItem('purchasedCourseId', JSON.stringify(selectedCourse.course._id))
    this.router.navigate([`courses/play/${selectedCourse?.course.courseId._id}`]);
  }

  isEmptyObject(obj) {
    return _.isEmpty(obj);
  }

}
